import React from "react";
import { Container as ChakraContainer, ContainerProps } from "@chakra-ui/react";

const Container = ({ ...props }: ContainerProps) => {
  return <ChakraContainer {...props}>{props.children}</ChakraContainer>;
};

export default Container;
